export default __webpack_public_path__ + "static/media/AdobeStock_307092601_x3.954260e7.jpg";